import { render } from "./DropdownItem.vue?vue&type=template&id=8b1b47fe&ts=true"
import script from "./DropdownItem.vue?vue&type=script&lang=ts"
export * from "./DropdownItem.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/jiangshanwen/workspace/website-3.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__